<template>
<div class="spbt">
  <v-layout class="a1a">
    <v-flex md1>Área</v-flex>
    <v-flex md2>EBITDA</v-flex>
    <v-flex md5>
      Porcentaje de Impacto <span v-if="!view_only">{{selected_item.impact_percentage}}%</span>
      <fs1-tooltip text="Estimación financiera de porcentaje productivo perdido en el área impactada producto de la falla catastrófica."/>
    </v-flex>
    <v-flex md4>
      Días de detención
      <fs1-tooltip text="Corresponde a los días de detención hasta la reposición de un nuevo activo (compra, envío e instalación)"/>
    </v-flex>
  </v-layout>
  <v-layout class="a1b">
    <in_impacted_areas :value="selected_item.impacted_area" md="1" :view_only="true" :abr="true" :no_label="true"/>
    <value-container md="2" :value="fix(get_ebit(selected_item.impacted_area))" style="text-align: right"/>
    <in-range v-model="selected_item.impact_percentage" md="5" :view_only="view_only"/>
    <in-num v-model="selected_item.mfl_days" md="4" :view_only="view_only"/>
  </v-layout>
</div>
</template>

<script>
import in_impacted_areas from '@/components/inputs/impacted_areas.vue';
export default {
  props: ['selected_item','view_only','current_fiscal_year'],
  components:{ in_impacted_areas},
  data() {
    return {
      
    };
  },
  computed: {
    c_ebits() { return this.ebits.filter(f => f.fiscal_year == this.current_fiscal_year)},
    ebits() { return this.$store.getters.ebits },
  },
  watch: {
    'selected_item.mfl_days'(v){
      if (isNaN(v)) this.selected_item.mfl_days = 0;
    }
  },
  created() {

  },
  methods: {
    get_ebit(id){ return (this.c_ebits.find(e => id === e.impacted_area)||{}).value },
  }, // methods
};
</script>

<style scoped>
.spbt>.layout>.flex_pad,
.spbt>.layout>.flex {
  padding-right: 24px;
  padding-left: 24px;
}
.spbt>.layout>.flex:nth-of-type(1),
.spbt>.layout>.flex_pad:nth-of-type(1) {
  padding-right: 24px;
  padding-left: 0;
}
.spbt>.layout>.flex:nth-last-of-type(1),
.spbt>.layout>.flex_pad:nth-last-of-type(1) {
  padding-right: 24px;
  padding-left: 0;
}
</style>